import React from 'react';
import PropTypes from 'prop-types';
import { Parser } from 'html-to-react';
import AttachedFile from '../../files/attachedFile';
import UserService from '../../../services/user.service';

const htmlToComponents = new Parser().parse;

const Comment = ({
  t,
  src,
  item,
  time,
  creator,
}) => (
  <div className="comment-wrp">
    <p className="fontmulisemi">{htmlToComponents(item.message)}</p>
    {item.files.map(file => (
      <div key={file.id}>
        <AttachedFile
          file={file}
          viewOnly
        />
      </div>
    ))}
    <p className="fontmulisemi">
      <span className="fedright">
        <img
          src={src}
          onError={(e) => { e.target.src = UserService.defaultAvatar; }}
          alt="feedbackimg"
          className="comm-img"
        />
        {creator}
        <span className="fedtime"><span className="text-lowercase">{t('At')}</span> {time}</span>
      </span>
    </p>
  </div>
);

Comment.propTypes = {
  t: PropTypes.func.isRequired,
};

export default Comment;



// WEBPACK FOOTER //
// ./src/components/comments/comment/Comment.jsx